// Importaciones de React y recursos.
import React, { useState, useEffect, useRef } from 'react';
import video1 from "../img/cardd-banerrr.webm";
import video2 from "../img/cardd-banner.webm";
import video3 from "../img/cardd-bannerr.webm";
import './styles.css'; // Estilos para el carrusel.

/**
 * Componente Carousel.
 * Muestra un carrusel de videos que cambia automáticamente cada 13 segundos
 * y que también puede ser controlado con botones de "anterior" y "siguiente".
 */
const Carousel = () => {
  // Estado para rastrear el índice del video actualmente visible.
  const [currentVideo, setCurrentVideo] = useState(0);
  
  // Array de objetos que contiene la fuente y el enlace opcional para cada video.
  const videos = [
    { src: video1, link: '/servicios#ciberseguridad' },
    { src: video2, link: null },
    { src: video3, link: null }
  ];

  // Referencia al elemento de video (aunque solo se asigna al primero).
  const videoRef = useRef(null);

  // Efecto para manejar el cambio automático de video.
  useEffect(() => {
    // Establece un intervalo que se ejecuta cada 13000 milisegundos (13 segundos).
    const intervalId = setInterval(() => {
      // Avanza al siguiente video, volviendo al primero si está en el último.
      setCurrentVideo((prevVideo) => (prevVideo + 1) % videos.length);
    }, 13000);

    // Función de limpieza: se ejecuta cuando el componente se desmonta para detener el intervalo.
    return () => clearInterval(intervalId);
  }, [videos.length]); // La dependencia asegura que el efecto se reinicie si cambia la cantidad de videos.

  return (
    // Contenedor principal del carrusel.
    <div className="carousel-container">
      {/* Contenedor de los slides que se moverá horizontalmente. */}
      <div
        className="carousel-slide"
        style={{
          // El `transform` mueve todo el contenedor hacia la izquierda.
          // `currentVideo * 100` calcula el porcentaje de desplazamiento.
          transform: `translateX(-${currentVideo * 100}%)`
        }}
      >
        {/* Itera sobre el array de videos para renderizar cada uno. */}
        {videos.map((video, index) => (
          <div key={index} className="carousel-video-wrapper" style={{ flex: '0 0 100%' }}>
            {/* Condición especial para el primer video. */}
            {index === 0 ? (
              <div style={{ display: 'block', width: '100%', height: '100%', position: 'relative' }}>
                <video ref={videoRef} muted loop playsInline className="carousel-video">
                  {/* Nota: El tipo de video aquí es mp4, pero el import es webm. Podría ser un error. */}
                  <source src={video.src} type="video/mp4" />
                  Tu navegador no soporta la etiqueta de video.
                </video>
              </div>
            ) : (
              <video autoPlay muted loop playsInline className="carousel-video">
                <source src={video.src} type="video/webm" />
                Tu navegador no soporta la etiqueta de video.
              </video>
            )}
          </div>
        ))}
      </div>

      {/* Botón para ir al video anterior. */}
      <button
        className="carousel-btn prev"
        onClick={() => setCurrentVideo((prevVideo) => (prevVideo === 0 ? videos.length - 1 : prevVideo - 1))}
      >
        {'<'}
      </button>

      {/* Botón para ir al video siguiente. */}
      <button
        className="carousel-btn next"
        onClick={() => setCurrentVideo((prevVideo) => (prevVideo + 1) % videos.length)}
      >
        {'>'}
      </button>
    </div>
  );
};

// Exporta el componente para su uso en otras partes de la aplicación.
export default Carousel;
